import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { ContextMenuItemView } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';

export function EditHospitalItem({
    hospitalId,
    editHospitalContextMenuItemView,
}: {
    hospitalId: number;
    editHospitalContextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const controls = useDrawerControls();

    return (
        <ContextMenuItem
            contextMenuItemView={editHospitalContextMenuItemView}
            onSelect={() =>
                controls.open({
                    type: 'edit-hospital',
                    props: {
                        hospitalId,
                    },
                })
            }
        />
    );
}
